import { useProductStore } from '#product/app/stores/product'

export default defineNuxtRouteMiddleware((to) => {
  if (import.meta.server) return

  const product = useProductGetter().getProductFromRoute(to)
  const { getProduct } = useProductStore()
  const { navigateToLocalized } = useRouterUtils()

  const { log } = useDatadog()

  if (!product || !getProduct(product)) {
    log(DATADOG_LOG_TYPES.Info, {
      component: 'middleware/cachedProduct',
      message: 'No cached product was found. Redirecting to /',
      messageContext: { ...to },
    })

    return navigateToLocalized('/')
  }
})
